import axios from "axios";
//axios.defaults.timeout = 10000

export const httpKeycloak = (token) => {
    if (!window.keycloak.isTokenExpired()) {
        return axios.create({
            baseURL: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-type": process.env.REACT_APP_REMOTE_BASE_API_CONTENT_TYPE
            }
        })
    } else {
        window.keycloak.logout();
    }
};



export default (token) => {
    if (!window.keycloak.isTokenExpired()) {
        return axios.create({
            baseURL: process.env.REACT_APP_REMOTE_BASE_API_URL,
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-type": process.env.REACT_APP_REMOTE_BASE_API_CONTENT_TYPE
            }
        })
    } else {
        window.keycloak.logout();
    }
};
